import { selector } from '@/lib/selectors';

// Leaf selectors: nothing from domain/ is imported here at runtime, so any
// selector module can depend on this one without an import cycle.
const companies = (state) => state.companies;

export const companyFeaturesStateSelector = selector(companies, (c) => c.companyFeatures);
export const companyGeneralFeaturesSelector = selector(companyFeaturesStateSelector, (f) => f.get('generalFeatures'));
export const companyGeneralFeatureFlagsSelector = selector(companyGeneralFeaturesSelector, (f) =>
  f.map((item) => item.get('value')),
);
export const companyApprovalsStampFeatureEnabledSelector = selector(companyGeneralFeatureFlagsSelector, (f) =>
  f.get('approval_stamp'),
);
